import { OpenAPI } from '@/api-df';
import { readActiveDevAuthHeaders } from '@/lib/dev-auth';
import { readRuntimeConfigValue } from '@/lib/runtime-config';

function normalizeGeneratedApiBaseUrl(value: string): string {
  const trimmed = value.trim().replace(/\/$/, '');

  if (trimmed === '/api/v1') {
    return '';
  }

  return trimmed.replace(/\/api\/v1$/, '');
}

export function configureApiClient() {
  const baseUrl = readRuntimeConfigValue('VITE_API_URL', '/api/v1');

  OpenAPI.BASE = normalizeGeneratedApiBaseUrl(baseUrl);
  OpenAPI.WITH_CREDENTIALS = true;
  OpenAPI.CREDENTIALS = 'include';
  OpenAPI.TOKEN = async () => '';
  OpenAPI.HEADERS = async () => {
    const headers: Record<string, string> = {};
    const devAuth = readActiveDevAuthHeaders();

    if (devAuth?.userId) {
      headers['X-Dev-User-Id'] = devAuth.userId;
    }

    if (devAuth?.botId) {
      headers['X-Dev-Bot-Id'] = devAuth.botId;
    }

    return headers;
  };
}

export default configureApiClient;
